import React from 'react';
import ServicePage from '../components/services/ServicePage';
import tabletopPos from '../data/services/tabletop-pos';

const TabletopPos: React.FC = () => <ServicePage data={tabletopPos} />;

export default TabletopPos;
